module.exports = __webpack_public_path__ + "img/UBCTanTan.79c337c1.jpg";